<template>
  <div class="welcome-section">
    <div class="welcome-content">
      <div class="welcome-header">
        <h1 class="welcome-title">
          {{ venueInfo.name || '排队会场' }}
        </h1>
        <p class="welcome-description">智能排队选择模式，高效分配资源，公平透明的团队决策系统</p>
      </div>

      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 左侧：可选需求列表 -->
        <div class="requirements-section">
          <div class="section-header">
            <span class="section-title">可选需求列表</span>
            <span class="section-count">共 {{ requirementPool.length || 0 }} 个需求</span>
          </div>
          <div class="requirements-list">
            <div v-for="requirement in requirementPool" :key="requirement.id" class="requirement-item">
              <div class="requirement-header">
                <span class="requirement-id purple">BR-{{ requirement.source_id }}</span>
                <a class="requirement-title" :href="requirementLink(requirement)" target="_blank">{{ requirement.source_name || '需求标题' }}嘻嘻嘻休息休息</a>
                <span class="requirement-price">{{ requirement.price || 0 }}<span class="currency-icon">BRP</span></span>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：参与团队列表 -->
        <div class="teams-section">
          <div class="section-header">
            <span class="section-title">参与团队列表</span>
            <span class="section-count">共 {{ teamList.length || 0 }} 个团队</span>
          </div>
          <div class="teams-list">
            <div v-for="team in teamList" :key="team.id" class="team-item">
              <div class="team-avatar">
                <a-icon type="team" />
              </div>
              <span class="team-name">{{ team.name }}</span>
              <span class="team-status">
                <span v-if="team.ready === true" class="team-ready">已准备</span>
                <span v-else class="team-not-ready">未准备</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 开始按钮 -->
      <div class="control-section">
        <a-space>
          <a-button v-has="{ code: 'business:venue:edit' }" :loading="startLoading" type="primary" size="large" :disabled="requirementPool.length === 0 || teamList.length === 0" class="start-btn" @click="startSelection"> 开始排队选择 </a-button>
          <a-button v-if="notReady.length > 0" :loading="readyLoading" type="primary" size="large" class="start-btn" @click="onReady"> 准备好了 </a-button>
        </a-space>
      </div>

      <!-- 流程说明 -->
      <div class="process-section">
        <h2 class="process-title">排队选择流程</h2>
        <div class="process-steps">
          <!-- 步骤1 -->
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <h3>准备阶段</h3>
              <p>各团队进入系统，查看可选择的需求列表和相关详情</p>
            </div>
          </div>

          <!-- 步骤2 -->
          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <h3>排队选择</h3>
              <p>系统按顺序邀请团队进行选择，每个团队有指定时间进行决策</p>
            </div>
          </div>

          <!-- 步骤3 -->
          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <h3>结果确认</h3>
              <p>所有团队完成选择后，系统生成最终分配结果并公示</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { venueStatusUpdate, venueAction } from '@/api/business/venue';

export default {
  name: 'WelcomeSection',
  props: {
    venueInfo: {
      type: Object,
      default: () => ({})
    },
    requirementPool: {
      type: Array,
      default: () => []
    },
    teamList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['change'],
  data() {
    return {
      startLoading: false,
      readyLoading: false
    };
  },
  computed: {
    requirementLink() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: {
            id: record.source_id
          }
        }).href;
      };
    },
    notReady() {
      const userId = this.$store.state.userInfo.id;
      console.log(this.teamList);
      console.log(this.teamList.filter(team => team.ready === false && team.ownerId === userId));
      return this.teamList.filter(team => team.ready === false && team.ownerId === userId);
    }
  },
  methods: {
    // 开始选择活动
    async startSelection() {
      this.startLoading = true;
      try {
        await venueStatusUpdate({
          id: this.venueInfo.id,
          status: 2
        });
        this.$emit('change');
        this.$message.success('排队选择活动正式开始！');
      } catch (error) {
        console.error('启动活动失败:', error);
        this.$message.error('启动活动失败');
      } finally {
        this.startLoading = false;
      }
    },

    onReady() {
      this.readyLoading = true;
      venueAction({
        venue_id: this.venueInfo.id,
        action: 'READY',
        record_id: 0
      })
        .then(() => {
          this.$emit('change');
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.readyLoading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.welcome-section {
  min-height: 100vh;
  background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
  color: #111827;
  font-family: 'Inter', system-ui, sans-serif;
  position: relative;
  overflow: hidden;
  padding: 1rem;
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%234F46E5' fill-opacity='0.02'%3E%3Ccircle cx='7' cy='7' r='3'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
    opacity: 0.5;
  }

  .welcome-content {
    text-align: center;
    max-width: 880px;
    position: relative;
    z-index: 1;
    margin: 0 auto;
    padding: 2rem 0 4rem;

    .welcome-header {
      margin-bottom: 3rem;

      .welcome-title {
        font-size: clamp(1.8rem, 5vw, 3rem);
        font-weight: 700;
        background: linear-gradient(135deg, #4f46e5, #818cf8);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 1rem;
        line-height: 1.2;
      }

      .welcome-description {
        font-size: 1.125rem;
        color: rgba(17, 24, 39, 0.7);
        line-height: 1.6;
        max-width: 600px;
        margin: 0 auto;
      }
    }

    .process-section {
      margin-top: 3rem;

      .process-title {
        font-size: 1.25rem;
        font-weight: 600;
        color: rgba(17, 24, 39, 0.9);
        margin-bottom: 2rem;
      }

      .process-steps {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        max-width: 600px;
        margin: 0 auto;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          left: 1rem;
          top: 0;
          bottom: 0;
          width: 2px;
          background: linear-gradient(to bottom, #4f46e5, #818cf8);
          border-radius: 1px;
        }

        .step-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          position: relative;

          .step-number {
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            background: linear-gradient(135deg, #4f46e5, #818cf8);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 0.875rem;
            flex-shrink: 0;
            z-index: 1;
            box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
          }

          .step-content {
            text-align: left;
            padding-top: 0.125rem;

            h3 {
              font-size: 1rem;
              font-weight: 600;
              color: rgba(17, 24, 39, 0.9);
              margin: 0 0 0.5rem 0;
            }

            p {
              color: rgba(17, 24, 39, 0.7);
              font-size: 0.875rem;
              line-height: 1.6;
              margin: 0;
            }
          }
        }
      }
    }

    // 主要内容区域
    .main-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
      margin-bottom: 3rem;
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 1.5rem;
      }
    }

    // 需求列表区域
    .requirements-section,
    .teams-section {
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      border: 1px solid rgba(17, 24, 39, 0.1);
      border-radius: 16px;
      padding-bottom: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(17, 24, 39, 0.1);
        padding: 0.7rem;

        .section-title {
          font-size: 1rem;
          font-weight: 500;
          color: rgba(17, 24, 39, 0.9);
        }

        .section-count {
          font-size: 0.875rem;
          color: #4f46e5;
          font-weight: 500;
          border-radius: 20px;
          padding: 0.25rem 0.75rem;
          background: rgba(59, 130, 246, 0.2);
        }
      }
    }

    // 需求项样式
    .requirements-list {
      display: flex;
      flex-direction: column;

      .requirement-item {
        padding: 0.5rem 1rem;

        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.1);
          border-color: rgba(79, 70, 229, 0.3);
          cursor: pointer;
        }

        .requirement-header {
          display: flex;
          align-items: center;

          .requirement-id {
            padding: 0.25rem 0.75rem;
            border-radius: 20px;
            font-size: 0.75rem;

            &.purple {
              background: rgba(139, 92, 246, 0.2);
              color: #7c3aed;
            }
          }
        }

        .requirement-title {
          font-size: 0.875rem;
          max-width: 240px;
          color: rgba(17, 24, 39, 0.9);
          margin: 0 0 0 0.875rem;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }

        .requirement-price {
          font-size: 0.875rem;
          color: #4f46e5;
          font-weight: 500;
          margin-left: auto;
        }

        .currency-icon {
          font-size: 0.5rem;
          margin-left: 0.1rem;
        }
      }
    }

    // 团队列表样式
    .teams-list {
      display: flex;
      flex-direction: column;

      .team-item {
        display: flex;
        align-items: center;
        gap: 0.875rem;
        padding: 0.5rem 1rem;

        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.1);
          border-color: rgba(79, 70, 229, 0.3);
          cursor: pointer;
        }

        .team-avatar {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: linear-gradient(135deg, #4f46e5, #818cf8);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          opacity: 0.7;
        }

        .team-name {
          font-size: 0.875rem;
          font-weight: 500;
          color: rgba(17, 24, 39, 0.9);
        }

        .team-status {
          font-size: 0.875rem;
          color: rgba(17, 24, 39, 0.7);
          margin-left: auto;
        }

        .team-ready {
          color: #fff;
          border-radius: 12px;
          padding: 0.1rem 0.5rem;
          background: linear-gradient(135deg, #4f46e5, #818cf8);
        }

        .team-not-ready {
          color: #86909c;
          border-radius: 12px;
          padding: 0.1rem 0.5rem;
          background: rgba(0, 0, 0, 0.1);
        }
      }
    }

    .control-section {
      .start-btn {
        background: linear-gradient(135deg, #4f46e5, #818cf8);
        border: none;
        border-radius: 50px;
        padding: 0.875rem 2.5rem;
        font-size: 1rem;
        font-weight: 600;
        height: auto;
        box-shadow: 0 8px 32px rgba(79, 70, 229, 0.3);
        transition: all 0.3s ease;
        color: white;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 40px rgba(79, 70, 229, 0.4);
          background: linear-gradient(135deg, #818cf8, #4f46e5);
        }

        &:focus {
          box-shadow: 0 8px 32px rgba(79, 70, 229, 0.3), 0 0 0 3px rgba(79, 70, 229, 0.1);
        }

        .start-icon {
          margin-left: 0.5rem;
        }
      }
    }
  }

  // 动画关键帧
  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    padding: 1rem;
    min-height: auto;

    .welcome-content {
      padding: 1rem 0 2rem;

      .welcome-header {
        margin-bottom: 2rem;

        .welcome-title {
          font-size: clamp(1.5rem, 4vw, 2.5rem);
        }

        .welcome-description {
          font-size: 1rem;
        }
      }

      .process-section {
        margin-bottom: 2rem;

        .process-steps {
          gap: 1.5rem;

          &::before {
            left: 0.75rem;
          }

          .step-item {
            .step-number {
              width: 1.5rem;
              height: 1.5rem;
              font-size: 0.75rem;
            }

            .step-content {
              h3 {
                font-size: 0.9rem;
              }

              p {
                font-size: 0.8rem;
              }
            }
          }
        }
      }

      .control-section {
        .start-btn {
          padding: 0.75rem 2rem;
          font-size: 0.9rem;
        }
      }
    }
  }
}
</style>
